import { render, staticRenderFns } from "./BuyOrderAuthorize.vue?vue&type=template&id=517b5afd&"
import script from "./BuyOrderAuthorize.vue?vue&type=script&lang=js&"
export * from "./BuyOrderAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports